import { useMemo} from 'react';
import { yyyyMMddHHmmssToOtherFormat } from '@bo-utils/dateUtils';

const useCoPrivacyPolicyContent = (contents) => {
  
const coPrivacyPolicyContent = useMemo ( 
  () => contents?.map((item) => (
    {
      label: `${yyyyMMddHHmmssToOtherFormat(item?.applyStartDateTime, 'yyyy-MM-dd')}`,
      key: `${yyyyMMddHHmmssToOtherFormat(item?.applyStartDateTime, 'yyyyMMdd')}`,
      value: `${item?.termsContent}`, 
    }
    )),
    [contents]
);

  return {
    coPrivacyPolicyContent,
  };

};

export default useCoPrivacyPolicyContent;

